import { useNavigate, useParams } from 'react-router-dom'
import { useLazyGetMeetingInfoQuery } from '../../app/services/conference.service'
import { useEffect } from 'react'
import { FixMeLater } from '../../types'

export default function VideoCallRedirect() {
  const navigate = useNavigate()
  const { meetingId = "", participantToken = "" } = useParams();
  const [getMeetingInfo] = useLazyGetMeetingInfoQuery()

  useEffect(() => {
    fetchMeetingUrl()
  }, [])

  const fetchMeetingUrl = async () => {
    try {
      const { data } = (await getMeetingInfo({ meetingId: meetingId })) as FixMeLater
      navigate(`/video-conference/${data.data.roomId}/${meetingId}/${participantToken}`)
    } catch (e) {
      navigate('/')
      console.log(e)
    }
  }

  return null
}
